export const ROLE = Object.freeze({
    ADMIN:1, // quyen admin
    SALES:7, // Quyen sale
    PARTNER: 9, //quyen partner
    MANAGER: 10,
    PARTNERSALES: 11,

    ADMIN_CODE:'Admin', // quyen admin
    SALES_CODE:'Sales', // Quyen sale
    PARTNER_CODE:'Partner', //quyen partner
    MANAGER_CODE: 'SystemManager',
    PARTNERSALES_CODE: 'PartnerSales'
})
